import { LookupItem } from "./lookup-item.model";

/**
 * Catch on sets.
 */
export class Catch {

    //Unique identifier for this catch
    catchID: String = '';

    //Foreign key
    fishingEventID: String = '';

    species: LookupItem = new LookupItem('');

    catchDisposition: LookupItem = new LookupItem('');

    retainedWeight?: number;

    retainedCount?: number;

    releasedWeight?: number;

    releasedCount?: number;

  constructor(sp: string, isHMS: boolean = false) {
      this.species = new LookupItem(sp);
    }


    /**
     * 
     * @param anon The array of anonymous objects to transform into Catch objects
     * @returns 
     */
    static transformAnonymous(anon: any[]) { 
        let items: Catch[] = [];
        anon.forEach(a => {
            let sp = LookupItem.transformAnonymous(a.species);
            let cd = LookupItem.transformAnonymous(a.catchDisposition);
            let item = new Catch('');

            item.catchID = a.catchID;
            item.fishingEventID = a.fishingEventID;
            item.species = sp;
            item.catchDisposition = cd;
            item.releasedCount = a.releasedCount;
            item.retainedCount = a.retainedCount;
            item.releasedWeight = a.releasedWeight;
            item.retainedWeight = a.retainedWeight;

            items.push(item);
        });
        return items;
    }


    
}
